import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useAppSelector } from '../../../../../../../../../application/store/useStore';
import useTranslate from '../../../../../../../../../localization/helpers';
var UserMessageBox = styled(Box)(function () { return ({
    width: 'auto',
    backgroundColor: 'rgba(200, 255, 247, 1)',
    padding: '10px',
    borderRadius: '10px',
    boxShadow: '0 24px 48px 0 #919EAB29',
    color: 'rgba(0, 78, 67, 1)',
    maxWidth: '85%',
    whiteSpace: 'normal',
    wordWrap: 'break-word'
}); });
var UserMessageTraining = function (_a) {
    var message = _a.message;
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    if (!!!message.question)
        return _jsx(_Fragment, {});
    return (_jsx(Box, { display: 'flex', flexDirection: 'column', children: _jsxs(Box, { display: 'flex', flexDirection: 'row-reverse', gap: '2px', children: [_jsx(Avatar, { sizes: 'small', variant: 'circular', sx: { width: '27px', height: '27px', marginTop: '16px', bgcolor: 'lightgrey' }, alt: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name, src: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name }), _jsxs(UserMessageBox, { children: [_jsx(Typography, { variant: 'body2', children: message.question }), _jsx(Box, { display: 'block', textAlign: 'right', children: _jsx(Typography, { variant: 'caption', display: 'block', align: 'right', children: new Date(message.time).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                    hour12: true,
                                    hour: '2-digit',
                                    minute: '2-digit'
                                }) }) })] })] }) }));
};
export default UserMessageTraining;
